export default __webpack_public_path__ + "dist/media/Crown.7fac628a.svg";